module.exports = __webpack_public_path__ + "img/O.56acc7a6.webp";